"use client"

export const FasApproach = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {/* Main Content */}
          <div className="md:col-span-2 animate-in slide-in-from-left duration-700">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-500 p-6 sm:p-8 border border-gray-100">
              <div className="border-l-4 border-amber-500 pl-6 mb-6">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">Our Approach</h2>
                <div className="text-xs sm:text-sm text-gray-500 uppercase tracking-wide">How We Make a Difference</div>
              </div>

              <div className="space-y-4 sm:space-y-5 text-gray-700 leading-relaxed text-lg md:text-xl mb-6 text-justify">
                <p>
                  <span className="font-bold text-3xl float-left mr-0.5 leading-none text-amber-600">O</span>
                  ur goal is to foster a conducive learning environment where students can thrive academically and realize their full potential.
                </p>

                <p>
                  Through strategic partnerships with schools, educational institutions, and local communities, we
                  identify the specific needs of students and work diligently to fulfill those needs.
                </p>

                <p>
                  We organize fundraising initiatives, donation drives, and collaborate with our friends to raise
                  awareness about the importance of education for all.
                </p>

                <p className="font-semibold text-gray-900">
                  By working together with our partners and supporters, we ensure that every student receives the
                  resources they need to succeed, creating lasting impact in communities across the region.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="md:col-span-1 space-y-6 animate-in slide-in-from-right duration-700" style={{ animationDelay: '200ms' }}>
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-500 p-5 sm:p-6 border border-gray-100">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 border-b-2 border-amber-500 pb-3 mb-4">
                What We Provide
              </h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="border-l-4 border-amber-600 pl-3 hover:pl-4 transition-all duration-300">
                  <span className="font-bold text-gray-900">Notebooks & Stationery:</span> Essential writing materials
                </li>
                <li className="border-l-4 border-amber-600 pl-3 hover:pl-4 transition-all duration-300">
                  <span className="font-bold text-gray-900">Digital Devices:</span> Technology for modern learning
                </li>
                <li className="border-l-4 border-amber-600 pl-3 hover:pl-4 transition-all duration-300">
                  <span className="font-bold text-gray-900">Toiletries:</span> Personal care essentials
                </li>
                <li className="border-l-4 border-amber-600 pl-3 hover:pl-4 transition-all duration-300">
                  <span className="font-bold text-gray-900">Educational Resources:</span> Books and learning aids
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-500 p-5 sm:p-6 border-2 border-amber-200 hover:border-amber-400">
              <h3 className="text-base sm:text-lg font-bold text-gray-900 border-b-2 border-amber-500 pb-3 mb-4">
                Student Testimonial
              </h3>
              <blockquote className="text-sm text-gray-700 italic leading-relaxed mb-3">
                "Thanks to Fly and Share, I now have the notebooks and supplies I need to focus on my studies. This
                program changed my life!"
              </blockquote>
              <div className="text-xs text-gray-600 font-medium">— Grade 10 Student</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
